

export const DistrictOptions = [
  { value: "ahmedabad", label: "Ahmedabad" },
  { value: "rajkot", label: "Rajkot" },
  { value: "surat", label: "Surat" },
  { value: "tapi", label: "Tapi" },
  { value: "vadodara", label: "Vadodara" },
  { value: "bhavnagar", label: "Bhavnagar" },
  { value: "junagadh", label: "Junagadh" },
  { value: "kutch", label: "Kutch" },
  { value: "mehsana", label: "Mehsana" },
  { value: "anand", label: "Anand" },
  { value: "gandhinagar", label: "Gandhinagar" },
];

export const DistrictOptionsAPMC = {
  isMulti: true,
  options:[  { value: "ahmedabad", label: "Ahmedabad" },
  { value: "rajkot", label: "Rajkot" },
  { value: "surat", label: "Surat" },
  { value: "tapi", label: "Tapi" },
  { value: "vadodara", label: "Vadodara" },
  { value: "bhavnagar", label: "Bhavnagar" },
  { value: "junagadh", label: "Junagadh" },
  { value: "kutch", label: "Kutch" },
  { value: "mehsana", label: "Mehsana" },
  { value: "anand", label: "Anand" },
  { value: "gandhinagar", label: "Gandhinagar" },]

  };

export const Scheme = [
  { value: 'sch1', label: 'Scheme 1' },
  { value: 'sch2', label: 'Scheme 2' },
  { value: 'sch3', label: 'Scheme 3' },
  
];

export const Purpose = [
  { value: 'pur1', label: 'Purpose 1' },
  { value: 'pur2', label: 'Purpose 2' },
  { value: 'pur3', label: 'Purpose 3' },
  { value: 'pur4', label: 'Purpose 4' },
  
];

export const schemeIdMap = {
  "Scheme for Establishing Modern Market Yards": 53,
  "Kisan Kalpvruksha Yojana": 54,
  "Assistance for Apni Mandi": 55,
  "Scheme to provide assistance for construction of retail outlets/agricultural malls in APMCs": 56,
  "Scheme for processing units in APMCs (general distribution)": 57,
  "Scheme to provide assistance for establishing large-sized warehouse and godown": 58,
  "Scheme to provide assistance for establishing Farmer Support Centers in the district’s APMCs, as well as for computerization of all APMCs.": 59
};

export const yardOptions = [
  {
    label: "મુખ્ય યાર્ડ // Main Yard",
    value: "main_yard",
    type: "mainYard"
  },
  {
    label: "શાકભાજી બજાર સબ યાર્ડ // Vegetable Market Sub-Yard",
    value: "veg_subyard",
    type: "subYard"
  },
  {
    label: "અનાજ અને દાળ વેપાર સબ યાર્ડ // Grain & Pulses Trading Sub-Yard",
    value: "grain_subyard",
    type: "subYard"
  },
  {
    label: "ફળ હરાજી સબ યાર્ડ // Fruit Auction Sub-Yard",
    value: "fruit_subyard",
    type: "subYard"
  },
  {
    label: "પશુપાલન વેપાર સબ યાર્ડ // Livestock Trading Sub-Yard",
    value: "livestock_subyard",
    type: "subYard"
  },
  {
    label: "પ્રોસેસિંગ અને ગ્રેડિંગ યુનિટ સબ યાર્ડ // Processing & Grading Unit Sub-Yard",
    value: "processing_subyard",
    type: "subYard"
  }
];